/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkResultDto } from './BeamConstancyWorkResultDto';
import {
    BeamConstancyWorkResultDtoFromJSON,
    BeamConstancyWorkResultDtoFromJSONTyped,
    BeamConstancyWorkResultDtoToJSON,
} from './BeamConstancyWorkResultDto';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { WorkState } from './WorkState';
import {
    WorkStateFromJSON,
    WorkStateFromJSONTyped,
    WorkStateToJSON,
} from './WorkState';

/**
 * 
 * @export
 * @interface BeamConstancyWorkStepDto
 */
export interface BeamConstancyWorkStepDto {
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkStepDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkStepDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ParameterCombinationDto}
     * @memberof BeamConstancyWorkStepDto
     */
    combination?: ParameterCombinationDto;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof BeamConstancyWorkStepDto
     */
    evaluations?: Array<EvaluationParameterDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BeamConstancyWorkStepDto
     */
    isExecutable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    workStepPreviewId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BeamConstancyWorkStepDto
     */
    evaluationIds?: Array<string> | null;
    /**
     * 
     * @type {WorkState}
     * @memberof BeamConstancyWorkStepDto
     */
    workState?: WorkState;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    workflowId?: string | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof BeamConstancyWorkStepDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkStepDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkStepDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof BeamConstancyWorkStepDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof BeamConstancyWorkStepDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {Array<BeamConstancyWorkResultDto>}
     * @memberof BeamConstancyWorkStepDto
     */
    results?: Array<BeamConstancyWorkResultDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkStepDto
     */
    $type?: BeamConstancyWorkStepDtoTypeEnum;
}


/**
 * @export
 */
export const BeamConstancyWorkStepDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoBeamConstancyWorkStepDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkStepDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamConstancyWorkStepDtoTypeEnum = typeof BeamConstancyWorkStepDtoTypeEnum[keyof typeof BeamConstancyWorkStepDtoTypeEnum];


/**
 * Check if a given object implements the BeamConstancyWorkStepDto interface.
 */
export function instanceOfBeamConstancyWorkStepDto(value?: unknown): value is BeamConstancyWorkStepDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamConstancyWorkStepDtoTypeEnum)[0];
}

export function BeamConstancyWorkStepDtoFromJSON(json: any): BeamConstancyWorkStepDto {
    return BeamConstancyWorkStepDtoFromJSONTyped(json, false);
}

export function BeamConstancyWorkStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamConstancyWorkStepDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'combination': !exists(json, 'combination') ? undefined : ParameterCombinationDtoFromJSON(json['combination']),
        'evaluations': !exists(json, 'evaluations') ? undefined : (json['evaluations'] === null ? null : (json['evaluations'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        'isExecutable': !exists(json, 'isExecutable') ? undefined : json['isExecutable'],
        'workStepPreviewId': !exists(json, 'workStepPreviewId') ? undefined : json['workStepPreviewId'],
        'evaluationIds': !exists(json, 'evaluationIds') ? undefined : json['evaluationIds'],
        'workState': !exists(json, 'workState') ? undefined : WorkStateFromJSON(json['workState']),
        'workflowId': !exists(json, 'workflowId') ? undefined : json['workflowId'],
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'commentEntityCompositeId': !exists(json, 'commentEntityCompositeId') ? undefined : json['commentEntityCompositeId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(BeamConstancyWorkResultDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function BeamConstancyWorkStepDtoToJSON(value?: BeamConstancyWorkStepDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'combination': ParameterCombinationDtoToJSON(value.combination),
        'evaluations': value.evaluations === undefined ? undefined : (value.evaluations === null ? null : (value.evaluations as Array<any>).map(EvaluationParameterDtoToJSON)),
        'isExecutable': value.isExecutable,
        'workStepPreviewId': value.workStepPreviewId,
        'evaluationIds': value.evaluationIds,
        'workState': WorkStateToJSON(value.workState),
        'workflowId': value.workflowId,
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'commentEntityCompositeId': value.commentEntityCompositeId,
        'commentCount': value.commentCount,
        'lastComment': value.lastComment,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(BeamConstancyWorkResultDtoToJSON)),
        '$type': value.$type,
    });
}

